import React, { useEffect, useState } from 'react';
import { getAmsmNewsLetter } from '../../Api'

const NewsLetter: React.FC = () => {
  const [amsmNewsLetter, setAmsmNewsLetter] = useState<string>('');

  const _getAmsmNewsLetter = async () => {
    const _response: any = await getAmsmNewsLetter({});
    if (_response.status) {
      setAmsmNewsLetter(_response.data);
    }
  };

  useEffect(() => {
    _getAmsmNewsLetter();
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: amsmNewsLetter }} />
  );
};

export default NewsLetter;